// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentProfileRepresentation } from './StudentProfileRepresentation'
import {
  StudentProfileRepresentationFromJSON,
  StudentProfileRepresentationFromJSONTyped,
  StudentProfileRepresentationToJSON,
} from './StudentProfileRepresentation'

/**
 *
 * @export
 * @interface StudentProfileRepresentationBaseApiResult
 */
export interface StudentProfileRepresentationBaseApiResult {
  /**
   *
   * @type {StudentProfileRepresentation}
   * @memberof StudentProfileRepresentationBaseApiResult
   */
  data?: StudentProfileRepresentation
}

/**
 * Check if a given object implements the StudentProfileRepresentationBaseApiResult interface.
 */
export function instanceOfStudentProfileRepresentationBaseApiResult(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function StudentProfileRepresentationBaseApiResultFromJSON(
  json: any,
): StudentProfileRepresentationBaseApiResult {
  return StudentProfileRepresentationBaseApiResultFromJSONTyped(json, false)
}

export function StudentProfileRepresentationBaseApiResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentProfileRepresentationBaseApiResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data')
      ? undefined
      : StudentProfileRepresentationFromJSON(json['data']),
  }
}

export function StudentProfileRepresentationBaseApiResultToJSON(
  value?: StudentProfileRepresentationBaseApiResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: StudentProfileRepresentationToJSON(value.data),
  }
}
